import { __assign } from "tslib";
import * as React from 'react';
import { getLegacyBaseDriverFromWrapper } from '../../common/base-driver';
import { TimeInput } from './time-input';
import { renderAndMountComponent } from '@wix/answers-lib';
import { createLegacyDeprecatedInputDriver } from '../../primitives/deprecated-input/input.legacy-driver';
import { Simulate } from 'react-dom/test-utils';
export var createTimeInputLegacyDriver = function (wrapper) {
    var baseDriver = getLegacyBaseDriverFromWrapper(wrapper, '.time-input', TimeInput.name);
    var timeInputElement = baseDriver.find('input').elem;
    return {
        getTime: function () { return createLegacyDeprecatedInputDriver(wrapper).getValue(); },
        enterTime: function (val) {
            createLegacyDeprecatedInputDriver(wrapper).enterValue(val);
            Simulate.blur(timeInputElement);
        },
        getPeriod: function () { return baseDriver.find('.period').getText(); },
        clickPeriod: function () { return baseDriver.find('.period').click(); },
        selectOption: function (idx) {
            baseDriver.find('.toggle-options-button').click();
            baseDriver.findAll('.time-options-menu .time-option').get(idx).click();
        }
    };
};
export var createTimeInput = function (props) {
    var elem = renderAndMountComponent(React.createElement(TimeInput, __assign({}, props)));
    return createTimeInputLegacyDriver(elem);
};
//# sourceMappingURL=time-input.legacy.driver.js.map